import { ColorScheme } from "./color_scheme.js";
import type { UITextElement } from "./ui_text_element.js";

const OUTLINE_W_DESIGN = 10;

export function setButtonTextOutline(
  texts: readonly ( UITextElement | null | undefined )[],
  active: boolean,
  active_color: string
): void
{
  const width = LayoutScaler.textBorderSizeFromDesign( OUTLINE_W_DESIGN );
  const color = active ? active_color : ColorScheme.gray_btn_outline;
  for ( const text of texts )
  {
    if ( !text ) continue;
    text.setOutline( width, color );
    text.invalidateSubtree();
  }
}
